module.exports = __webpack_public_path__ + "static/img/9.3d42f18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/9.jpg
// module id = 8U5r
// module chunks = 29